export const GRID_TWO = 'grid grid-cols-1 gap-4 md:grid-cols-2'
export const GRID_THREE = 'grid grid-cols-1 gap-4 md:grid-cols-3'
